<script lang="ts">
export default {
  name: 'FilterBar',
};
</script>

<script setup lang="ts">
import { registerResizeItem } from '@/utilities/resize';
import { onMounted } from 'vue';

onMounted(() => {
  registerResizeItem({ name: 'filter-bar', selector: 'filter-bar' });
});
</script>

<template>
  <v-slide-group id="filter-bar" class="filter-bar" show-arrows>
    <slot></slot>
  </v-slide-group>
</template>

<style scoped>
.filter-bar {
  background: var(--v-gray-lighten5);
  padding: 0.5rem 1rem;
  border-top: 1px solid var(--v-border-base);
  border-bottom: 1px solid var(--v-border-base);
}
</style>
